import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'

const OverflowScroll = ({ size = 'large', ...rest }) => {
  const theme = useTheme()

  return (
    <div
      css={{
        display: 'flex',

        '> *': {
          position: 'relative',
          flex: 'none',
        },

        [theme.mq.small__max]: {
          overflowX: 'auto',
          maxWidth: '100%',
          scrollbarWidth: 'none',
          MsOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch',
          maskImage: `linear-gradient(
                    90deg,
                    transparent,
                    ${theme.color.light.base} 10%,
                    ${theme.color.light.base} 90%,
                    transparent
                  )`,

          '&::-webkit-scrollbar': {
            width: 0,
          },

          '> *': {
            marginLeft: theme.space[size] / 2,
            marginRight: theme.space[size] / 2,

            '&:last-of-type::after': {
              content: "''",
              display: 'block',
              position: 'absolute',
              right: -theme.space[size] / 2,
              width: theme.space[size] / 2,
              height: 1,
            },
          },
        },

        [theme.mq.medium]: [
          {
            flexWrap: 'wrap',
            justifyContent: 'center',
            marginTop: -theme.space[size],
            marginLeft: -theme.space[size],

            '> *': {
              marginTop: theme.space[size],
              marginLeft: theme.space[size],
            },
          },
        ],
      }}
      {...rest}
    />
  )
}

OverflowScroll.propTypes = {
  size: PropTypes.oneOf(['large', 'xlarge']),
}

export default OverflowScroll
